<template>
  <div class="page__sidebar h-100 sidebar-archive">
    <component
      :is="sideBar"
      :store="store"
      :not-read="notRead"
      :drafts="drafts"
      :issues="issues"
      :counters="allCounters"
      :options="options"
      :custom-options="customOptions"
      :selected-option="selectedOption"
      :disable-add-filter="disableAddFilter"
      label-custom-option="filterName"
      @expand="expand()"
      @contract="contract()"
      @setDefaultOptionParent="setDefaultOption($event)"
      @update:selected-option="changeSelectedOption($event)"
      @click-add-filter="$emit('click-add-filter')"
      @remove-option="removeCustomOption($event)"
      @update-option="showUpdateModal($event)"
      @rename-option="showRenameModal($event)"
    />
    <modal-confirmation
      id="archiveSideBarConfirmationModal"
      ref="confirmationModal"
    />
    <rename-custom-filter-modal
      id="renameCustomFilterModal"
      ref="renameModal"
      @ok="renameCustomOption($event)"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import store from './archiveSideBarStore'
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import RenameCustomFilterModal from '@/components/customFilter/RenameCustomFilterModal'
import { ToastUtils } from '@/shared/util/toast-utils'

export default {
    name: 'ArchiveSideBar',
    components: {
        ModalConfirmation,
        RenameCustomFilterModal
    },
    props: {
        counters: { type: Object } // a map containing the numbers for each badge
    },
    data() {
        return {
            store: store,
            state: store.state
        }
    },
    computed: {
        sideBar() {
            return this.state.sideBar
        },
        customOptions() {
            return this.state.customOptions
        },
        options() {
            return this.state.options
        },
        selectedOption() {
            return this.state.selectedOption
        },
        disableAddFilter() {
            return this.gridRouteName !== this.$route.name
        },
        gridRouteName() {
            return this.state.gridRouteName
        },
        notRead() {
            return this.counters && this.counters.requestsWithReportNotReaded
        },
        drafts() {
            return this.counters && this.counters.draftRequests
        },
        issues() {
            return this.counters && this.counters.requestsWithIssue
        },
        allCounters() {
            return this.counters
        }
    },
    methods: {
        changeSelectedOption(value) {
            store.setSelectedOption(value)
            this.$router.push({ name: this.gridRouteName })
            this.$emit('changed-option', value)
        },
        selectDefaultOption() {
            store.selectDefaultOption()
            this.$emit('changed-option', this.state.selectedOption)
        },
        removeCustomOption(option) {
            this.$refs.confirmationModal.ask(async () => {
                if (await store.removeCustomOption(option.id)) {
                    ToastUtils.showToastSuccess(this.$tc('global.filterDeleted'))
                }
            })
        },
        showRenameModal(customFilter) {
            const filter = {
                ...customFilter,
                label: customFilter.filterName
            }
            this.$refs.renameModal.show(filter)
        },
        async renameCustomOption(customFilter) {
            await store.renameCustomOption(customFilter)
        },
        showUpdateModal(option) {
            this.$refs.confirmationModal.ask(() => {
                this.$emit('update-option', option)
            })
        },
        async expand() {
            await store.expandSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        async contract() {
            await store.contractSideBar()
            Vue.nextTick(() => { this.$emit('changed-width') })
        },
        async setDefaultOption(ev) {
            store.setDefaultOption(ev)
            await store.saveConfig()
        }
    }
}
</script>
